/*
 * TEKOTE scroll-trigger reveal animation
 * .tk-reveal elements を IntersectionObserver で監視 → view 進入で .is-visible 付与
 * prefers-reduced-motion: reduce → 即 visible (animation skip)
 * IntersectionObserver 非対応 browser → 即 visible (graceful degradation)
 *
 * Theme-editor (Shopify.designMode) 対応:
 *  - designMode では animation を skip し全 .tk-reveal を即 .is-visible 化。
 *    editor が 1 文字ごとに section を再描画しても、新 DOM が opacity:0 のまま残って
 *    プレビューが真っ白になる事故を防ぐ。
 *  - shopify:section:load で再描画 section 内を再 reveal / 再 observe (live の dynamic section も救済)。
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REVEAL_SELECTOR = '.tk-reveal';
  var VISIBLE_CLASS = 'is-visible';

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function revealAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
      el.classList.add(VISIBLE_CLASS);
    });
  }

  function observeWithin(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll(REVEAL_SELECTOR + ':not(.' + VISIBLE_CLASS + ')');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      revealAll(scope);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            obs.unobserve(entry.target);
          }
        });
      },
      {
        // 🔴 threshold は 0 にすること。
        // intersectionRatio は「要素の面積のうち見えている割合」なので、
        // 要素が viewport より高いと最大値が (viewport 高 / 要素高) で頭打ちになる。
        // 旧値 0.15 では、viewport の約 6 倍を超える高さの要素で最大比率が 0.15 に
        // 届かず、observer が一度も発火しない = opacity:0 のまま固着して真っ白になる。
        // (実例: PDP ギャラリーが約 9,000px になり最大比率 0.10 で永久に非表示)
        threshold: 0,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    // theme editor: animation を無効化し常に表示 (再描画で真っ白になるのを防ぐ)
    if (isDesignMode()) {
      revealAll(document);
      return;
    }

    var reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealAll(document);
      return;
    }

    observeWithin(document);
    installSafetyNet();
  }

  /*
   * 保険: observer が何らかの理由で発火しなかった要素を救済する。
   * 「すでに viewport の下端より上にあるのに、まだ非表示のまま」の要素だけを対象にするので、
   * 画面より下にある要素の animation は潰さない。
   * 画像の遅延読み込みで高さが後から変わる場合があるため load 後にも 1 回走らせる。
   */
  function rescueStuck() {
    var els = document.querySelectorAll(REVEAL_SELECTOR + ':not(.' + VISIBLE_CLASS + ')');
    if (!els.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add(VISIBLE_CLASS);
    });
  }

  function installSafetyNet() {
    window.addEventListener('load', function () {
      rescueStuck();
      setTimeout(rescueStuck, 1200);
    });
    var t = null;
    window.addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () { t = null; rescueStuck(); }, 400);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // theme editor で section が再描画されたら、その section 内を再 reveal / 再 observe
  document.addEventListener('shopify:section:load', function (event) {
    if (isDesignMode()) {
      revealAll(event.target);
    } else {
      observeWithin(event.target);
    }
  });

  // section / block 選択時にも念のため表示を保証 (editor のみ)
  document.addEventListener('shopify:section:select', function (event) {
    if (isDesignMode()) revealAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    if (isDesignMode()) revealAll(event.target);
  });
})();

/*
 * TEKOTE Shop Visit gallery: dot indicator sync (scroll ↔ active dot)
 * Native scroll-snap carousel + JS で dot indicator を同期 + click で scroll
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function initGallery(galleryEl) {
    var track = galleryEl.querySelector('[data-shop-gallery-track]');
    var dotsContainer = galleryEl.querySelector('[data-shop-gallery-dots]');
    if (!track || !dotsContainer) return;
    var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-shop-gallery-dot]'));
    if (dots.length === 0) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length === 0) return;

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        if (i === index) dot.classList.add('is-active');
        else dot.classList.remove('is-active');
      });
    }

    // Scroll → dot sync
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var itemWidth = track.clientWidth;
        if (itemWidth === 0) return;
        var index = Math.round(track.scrollLeft / itemWidth);
        index = Math.max(0, Math.min(items.length - 1, index));
        setActiveDot(index);
      }, 80);
    }, { passive: true });

    // Dot click → scroll
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-shop-gallery-dot'), 10);
        if (isNaN(index)) return;
        var itemWidth = track.clientWidth;
        track.scrollTo({ left: itemWidth * index, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
